import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import DeleteIcon from '../../icons/DeleteIcon';
import MailTable from '../../common/mailTable';
import {IndeterminateCheckbox, IndeterminateAllCheckbox} from '../../common/mailFilters';

export const internalUsersColumns = (props) => [
  {
    'Header': 'USUARIO',
    'accessor': 'username',
  },
  {
    'Header': 'NOMBRE',
    'accessor': 'name',
  },
  {
    'Header': 'CORREO',
    'accessor': 'email',
    'Cell': ({row}) => {
      const {email} = row.original;
      return email ? email.toLowerCase() : '';
    },
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
    'defaultCanFilter': true,
    'Filter': IndeterminateAllCheckbox,
    'filter': 'internal',
    'Cell': ({row}) => {
      const {status} = row.original;
      return (
        <IndeterminateCheckbox
          checked={status === 'S'}
          index={row.index}
          userType="internal"
        />
      );
    },
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      const {username, mailGroup} = row.original;
      return (
        <DeleteIcon username={username} group={mailGroup} dataType="internal" />
      );
    },
  },
];

class InternalUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {'allChecks': false};
  }

  renderLoaderOrUsers = () => {
    const {loading, internalUsersList, group, disabled} = this.props;
    const {allChecks} = this.state;
  
    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <MailTable
        group={group}
        list={internalUsersList}
        isusersList={true}
        userType="internal"
        disabled={disabled}
        allChecks={allChecks}
        columnsTableWithProps={internalUsersColumns}
      />
    );
  };

  render() {
    return (
      <Card raised fluid>
        {this.renderLoaderOrUsers()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'internalUsersList': state.internalUsers.list,
    'loading': state.internalUsers.loading,
    'disabled': state.internalUsers.disabled,
  };
};

const {fetchInternalUsersByGroup} = Actions;
export default connect(mapStateToProps, {
  fetchInternalUsersByGroup,
})(InternalUsers);
